// ToDo: delete enum: temporary - types getting from server
export enum KnmSubjectTypeCodesEnum {
  UL_IP = 'UL_IP',
  ULIP = 'ULIP',
  OGV = 'OGV',
  OMS = 'OMS',
}
